package fr.frux.core.designsystem.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.semantics.LiveRegionMode
import androidx.compose.ui.semantics.liveRegion
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.unit.dp

/**
 * Bandeau d'avertissement de doublon : un arbre existe déjà tout près du repère. Il ne bloque rien,
 * il propose de confirmer que c'est le même. Annoncé poliment aux lecteurs d'écran à son apparition.
 * [stacked] place le bouton sous le texte (grand écran), sinon il reste sur la ligne.
 */
@Composable
fun DuplicateNearbyBanner(
    glyph: ImageVector,
    tint: Color,
    title: String,
    subtitle: String,
    confirmLabel: String,
    onConfirm: () -> Unit,
    modifier: Modifier = Modifier,
    stacked: Boolean = false,
) {
    val scheme = MaterialTheme.colorScheme
    Surface(
        modifier = modifier.fillMaxWidth().semantics { liveRegion = LiveRegionMode.Polite },
        shape = RoundedCornerShape(20.dp),
        color = scheme.tertiaryContainer,
        contentColor = scheme.onTertiaryContainer,
        shadowElevation = 2.dp,
    ) {
        Row(
            modifier = Modifier.padding(start = 14.dp, top = 12.dp, end = 8.dp, bottom = 12.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(12.dp),
        ) {
            TreeGlyphDisc(glyph = glyph, tint = tint, size = 40.dp)
            if (stacked) {
                Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                    BannerText(title, subtitle)
                    FruxButton(text = confirmLabel, onClick = onConfirm, style = FruxButtonStyle.Tonal)
                }
            } else {
                Column(modifier = Modifier.weight(1f)) { BannerText(title, subtitle) }
                FruxButton(text = confirmLabel, onClick = onConfirm, style = FruxButtonStyle.Tonal)
            }
        }
    }
}

@Composable
private fun BannerText(
    title: String,
    subtitle: String,
) {
    Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
        Text(text = title, style = MaterialTheme.typography.titleMedium)
        Text(text = subtitle, style = MaterialTheme.typography.bodyMedium)
    }
}
